import MetaDashboard from "@/components/Apps/Campaigns/MetaDashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_auth/dashboard/_layout/meta")({
  component: MetaDashboard,
  beforeLoad: () => ({
    title: "Meta Dashboard",
    headerTitle: "Meta Dashboard",
    headerDescription: "Aggregate view across all apps and campaigns",
  }),
});
